// extracted by mini-css-extract-plugin
export default {"button":"ApprovePaymentButton__button--Afe9Y7","approvedIcon":"ApprovePaymentButton__approvedIcon--9SliDk"};